<lms-breadcrumb [label]="customization?.name"></lms-breadcrumb>
<div class="gl-roleplay">
  <gl-customization-roleplay
    [customizationId]="customizationId"
    (customizationLoaded)="setCustomization($event)"
    (savePlayers)="savePlayers($event)"
    (unsubscribePlayers)="unsubscribePlayers($event)"
  ></gl-customization-roleplay>
</div>
